// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__9RHbX","requiredAsterisk":"Info_requiredAsterisk__2k344"};